import React from 'react'
import SaleDetailModal from '../SaleDetailModal'
import { SALE_STATUSES, QUOTE_STATUSES, INVOICE_STATUSES } from './constants'


function modeMeta(activeTab, t, lang) {
  if (activeTab === 'quotes') {
    return {
      title: t.quotesTitle || t.quotes,
      subtitle: t.quotesTrack || (lang === 'fr'
        ? 'Créez et envoyez des devis clients.'
        : 'Create and send client quotes.'),
      formTitle: t.addNewQuote || (lang === 'fr' ? 'Nouveau devis' : 'New quote'),
      submit: t.addQuote || (lang === 'fr' ? 'Ajouter le devis' : 'Add quote'),
      listTitle: t.allQuotes || (lang === 'fr' ? 'Tous les devis' : 'All quotes'),
      defaultStatus: 'quote',
      statusFilter: QUOTE_STATUSES,
    }
  }
  if (activeTab === 'invoices') {
    return {
      title: t.invoicesTitle || t.invoices,
      subtitle: t.invoicesTrack || (lang === 'fr'
        ? 'Créez, suivez et envoyez les factures.'
        : 'Create, track and send invoices.'),
      formTitle: t.addNewInvoice || (lang === 'fr' ? 'Nouvelle facture' : 'New invoice'),
      submit: t.addInvoice || (lang === 'fr' ? 'Ajouter la facture' : 'Add invoice'),
      listTitle: t.allInvoices || (lang === 'fr' ? 'Toutes les factures' : 'All invoices'),
      defaultStatus: 'invoice',
      statusFilter: INVOICE_STATUSES,
    }
  }
  return {
    title: t.salesManagement,
    subtitle: t.trackSales,
    formTitle: t.addNewSale,
    submit: t.addSale,
    listTitle: t.allSales,
    defaultStatus: 'quote',
    statusFilter: null,
  }
}

export function renderSell(ctx) {
  const {
    activeTab,
    filteredSales,
    handleAddSale,
    handleDeleteSale,
    handleDeleteSaleAndClose,
    handleSaleStatusChange,
    handleSaveSaleDetail,
    lang,
    saleForm,
    saleSearch,
    saleStatus,
    sales,
    selectedSale,
    setSaleForm,
    setSaleSearch,
    setSelectedSale,
    t,
    totalSales,
  } = ctx

  const billingTabs = ['sell', 'quotes', 'invoices']
  if (!billingTabs.includes(activeTab) && !selectedSale) return null

  const meta = modeMeta(activeTab, t, lang)
  const visible = meta.statusFilter
    ? filteredSales.filter((s) => meta.statusFilter.includes(s.status))
    : filteredSales

  const quoteCount = sales.filter((s) => QUOTE_STATUSES.includes(s.status)).length
  const invoiceCount = sales.filter((s) => INVOICE_STATUSES.includes(s.status)).length
  const paidCount = sales.filter((s) => s.status === 'paid').length

  return (
    <>
      {billingTabs.includes(activeTab) && (
        <div className="dash-section">
          <div className="dash-section-header">
            <h2>{meta.title}</h2>
            <p>{meta.subtitle}</p>
          </div>

          <div className="dash-stats-grid">
            <div className="dash-stat-card">
              <div className="dash-stat-icon blue">📝</div>
              <div>
                <p className="dash-stat-label">{t.quotes}</p>
                <p className="dash-stat-value">{quoteCount}</p>
              </div>
            </div>
            <div className="dash-stat-card">
              <div className="dash-stat-icon orange">🧾</div>
              <div>
                <p className="dash-stat-label">{t.invoices || (lang === 'fr' ? 'Factures' : 'Invoices')}</p>
                <p className="dash-stat-value">{invoiceCount}</p>
              </div>
            </div>
            <div className="dash-stat-card">
              <div className="dash-stat-icon green">✅</div>
              <div>
                <p className="dash-stat-label">{t.paid || (lang === 'fr' ? 'Payées' : 'Paid')}</p>
                <p className="dash-stat-value">{paidCount}</p>
              </div>
            </div>
            <div className="dash-stat-card">
              <div className="dash-stat-icon purple">💰</div>
              <div>
                <p className="dash-stat-label">{t.totalRevenue}</p>
                <p className="dash-stat-value">${totalSales.toLocaleString()}</p>
              </div>
            </div>
          </div>

          <div className="dash-form-card">
            <h3>{meta.formTitle}</h3>
            <form
              className="dash-form"
              onSubmit={(e) => {
                if (!saleForm.status) {
                  setSaleForm((p) => ({ ...p, status: meta.defaultStatus }))
                }
                handleAddSale(e)
              }}
            >
              <div className="dash-form-row">
                <label>
                  {t.client} <span className="dash-required">*</span>
                  <input
                    type="text"
                    value={saleForm.client}
                    onChange={(e) => setSaleForm((p) => ({ ...p, client: e.target.value }))}
                    placeholder="Client name or company"
                  />
                </label>
                <label>
                  {t.productService} <span className="dash-required">*</span>
                  <input
                    type="text"
                    value={saleForm.product}
                    onChange={(e) => setSaleForm((p) => ({ ...p, product: e.target.value }))}
                    placeholder="Cloud Server Bundle"
                  />
                </label>
              </div>
              <div className="dash-form-row">
                <label>
                  {t.amount} <span className="dash-required">*</span>
                  <input
                    type="text"
                    value={saleForm.amount}
                    onChange={(e) => setSaleForm((p) => ({ ...p, amount: e.target.value }))}
                    placeholder="$2,500"
                  />
                </label>
                <label>
                  {t.date}
                  <input
                    type="date"
                    value={saleForm.date}
                    onChange={(e) => setSaleForm((p) => ({ ...p, date: e.target.value }))}
                  />
                </label>
              </div>
              <div className="dash-form-row">
                <label>
                  {t.status}
                  <select
                    value={saleForm.status || meta.defaultStatus}
                    onChange={(e) => setSaleForm((p) => ({ ...p, status: e.target.value }))}
                  >
                    {SALE_STATUSES.map((o) => (
                      <option key={o.value} value={o.value}>
                        {o.label[lang] || o.label.en}
                      </option>
                    ))}
                  </select>
                </label>
                <label>
                  {t.notes}
                  <input
                    type="text"
                    value={saleForm.notes}
                    onChange={(e) => setSaleForm((p) => ({ ...p, notes: e.target.value }))}
                    placeholder="Additional notes..."
                  />
                </label>
              </div>
              <div className="dash-form-row">
                <label>
                  {lang === 'fr' ? 'URL de la facture' : 'Invoice URL'}
                  <input
                    type="url"
                    value={saleForm.invoiceUrl || ''}
                    onChange={(e) => setSaleForm((p) => ({ ...p, invoiceUrl: e.target.value }))}
                    placeholder="https://…"
                  />
                </label>
              </div>
              <div className="dash-form-actions">
                <button className="dash-btn primary" type="submit">{meta.submit}</button>
                {saleStatus && <span className="dash-status-msg">{saleStatus}</span>}
              </div>
            </form>
          </div>

          <div className="dash-table-card">
            <div className="dash-table-header">
              <h3>
                {meta.listTitle} ({visible.length})
              </h3>
              <input
                className="dash-search"
                type="search"
                placeholder={t.searchSales}
                value={saleSearch}
                onChange={(e) => setSaleSearch(e.target.value)}
              />
            </div>
            {visible.length === 0 ? (
              <div className="dash-empty-state">
                <span>💼</span>
                <p>{sales.length === 0 ? t.noProjects : t.noResults}</p>
              </div>
            ) : (
              <div className="dash-table-wrap">
                <table className="dash-table">
                  <thead>
                    <tr>
                      <th>Reference</th>
                      <th>Client</th>
                      <th>Product</th>
                      <th>Amount</th>
                      <th>Date</th>
                      <th>Notes</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {visible.map((s) => (
                      <tr
                        key={s.id}
                        className="dash-row-clickable"
                        onClick={() => setSelectedSale(s)}
                        title={lang === 'fr' ? 'Voir le détail' : 'View details'}
                      >
                        <td className="dash-ref">
                          <button
                            type="button"
                            className="dash-link-btn"
                            onClick={(e) => {
                              e.stopPropagation()
                              setSelectedSale(s)
                            }}
                          >
                            {s.reference || '—'}
                          </button>
                        </td>
                        <td>{s.client}</td>
                        <td>{s.product}</td>
                        <td>
                          <strong>{s.amount}</strong>
                        </td>
                        <td>{s.date ? new Date(s.date).toLocaleDateString() : '—'}</td>
                        <td className="dash-muted">{s.notes || '—'}</td>
                        <td onClick={(e) => e.stopPropagation()}>
                          <select
                            className="dash-status-select-sm"
                            value={s.status}
                            onChange={(e) => handleSaleStatusChange(s.id, e.target.value)}
                          >
                            {SALE_STATUSES.map((o) => (
                              <option key={o.value} value={o.value}>
                                {o.label[lang] || o.label.en}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td className="dash-table-actions" onClick={(e) => e.stopPropagation()}>
                          <button
                            type="button"
                            className="dash-btn secondary small"
                            onClick={() => setSelectedSale(s)}
                          >
                            {lang === 'fr' ? 'Voir' : 'View'}
                          </button>
                          <button
                            type="button"
                            className="dash-delete-btn"
                            onClick={() => handleDeleteSale(s.id)}
                          >
                            {t.remove}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}

      {selectedSale && (
        <SaleDetailModal
          sale={selectedSale}
          lang={lang}
          onClose={() => setSelectedSale(null)}
          onSave={handleSaveSaleDetail}
          onDelete={handleDeleteSaleAndClose}
          onStatusChange={handleSaleStatusChange}
        />
      )}
    </>
  )
}
